import environment from "../../common/environment";
import { getResponseData } from "../../common/utils/api-utils";
import { AbandonedCartPreferenceActions } from "./abandoned-cart-preference.interface";


const env = environment();

export async function getAbandonedCartPreferenceApiCall(token: string) {
  return await getResponseData(
    new Request(`${env.magentoUrl}/rest/V1/preference/abandoned_cart/${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }));
}

export async function updateAbandonedCartPreferenceApiCall(token: string, action: AbandonedCartPreferenceActions) {
  return await getResponseData(
    new Request(`${env.magentoUrl}/rest/V1/preference/abandoned_cart/${token}/${action}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }));
}
